import { useQuery } from "@tanstack/react-query";
import { getBlogPosts } from "../blog";

export function useBlogPosts() {
  return useQuery({
    queryKey: ["blogPosts"],
    queryFn: getBlogPosts,
  });
}
